import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

const APIResultMessage = ({ error = null, success = null }) => {
    const [visible, setVisible] = useState(false);
    const [errorVisible, setErrorVisible] = useState(false);
    const [successVisible, setSuccessVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [color, setColor] = useState('success');

    useEffect(() => {
        if (error) {
            const errorMsg = error.response?.data || error.message || 'An unexpected error occurred';
            setMessage(errorMsg);
            setColor('danger');
            setVisible(true);
            setErrorVisible(true);
        } else if (success && !successVisible) {
            setMessage(success.message);
            setColor('success');
            setVisible(true);
            setSuccessVisible(true)
        }
    }, [error, success]);

    useEffect(() => {
        if (visible) {
            const timer = setTimeout(() => {
                setVisible(false);
                setSuccessVisible(false)
                setErrorVisible(false)
            }, 5000); // Automatically close after 5 seconds
            return () => clearTimeout(timer);
        }
    }, [visible]);

    const handleClose = () => {setVisible(false);setSuccessVisible(false);setErrorVisible(false)}

    const sanitizedHtmlMessage = useMemo(() => {
        const sanitizedMessage = DOMPurify.sanitize(message);
        return parse(sanitizedMessage);
    }, [message]);

    return (
        <Alert color={color} isOpen={visible} toggle={handleClose} fade={false}>
            <div className="error-display">{sanitizedHtmlMessage}</div>
        </Alert>
    );
};

APIResultMessage.propTypes = {
    error: PropTypes.shape({
        response: PropTypes.shape({
            data: PropTypes.string,
        }),
        message: PropTypes.string,
    }),
    success: PropTypes.shape({
        message: PropTypes.string,
    }),
};

export default APIResultMessage;

/*transition={{
            timeout: 300,
            appear: true,
            enter: true,
            exit: true
          }}>*/